<template>
  <v-layout
    justify-start
    align-center >
    <v-flex>
      <v-checkbox
        v-model="item.checked"
        @change="(value) => update(item.update, value)"
      />
    </v-flex>
    <v-flex style="width: 100%">
      <v-textarea
        :label="item.label"
        :value="item.value"
        rows="3"
        readonly
        disabled
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { onOffByValue } from '../../options';

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    update(code, value) {
      const { text } = onOffByValue(value);
      return this.$emit('update', code, text);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/CpCheckbox.vue